import React from "react";
import strings from "translate/language";
import "./PasswordResetEmailPreview.css";

/**
 * Preview of mail type 16 — password reset notice (no credentials).
 */
const PasswordResetEmailPreview = ({ recipientName = "" }) => {
  const name =
    String(recipientName || "").trim() ||
    strings.passwordResetEmailPreviewSampleName;
  const greeting = strings.passwordResetEmailPreviewGreeting.replace(
    "{name}",
    name
  );

  return (
    <div
      className="justo-mail-preview"
      role="region"
      aria-label={strings.passwordResetEmailPreviewLabel}
    >
      <p className="justo-mail-preview__label">
        {strings.passwordResetEmailPreviewLabel}
      </p>
      <div className="justo-mail-preview__card">
        <div className="justo-mail-preview__meta">
          <span className="justo-mail-preview__meta-key">
            {strings.passwordResetEmailPreviewSubject}
          </span>
          <span className="justo-mail-preview__meta-value">
            {strings.passwordResetEmailPreviewSubjectValue}
          </span>
        </div>
        <div className="justo-mail-preview__body">
          <p className="justo-mail-preview__greeting">
            <strong>{greeting}</strong>
          </p>
          <p>{strings.passwordResetEmailPreviewBody1}</p>
          <p>{strings.passwordResetEmailPreviewBody2}</p>
          <p>{strings.passwordResetEmailPreviewBody3}</p>
          <p className="justo-mail-preview__signoff">
            {strings.passwordResetEmailPreviewSignoff}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetEmailPreview;
